<!-- src/app/app.component.html -->
<div class="layout-overflow">
  <div
    class="layout-canvas"
    [ngClass]="{ 'nav-open': navOpen, 'nav-closed': !navOpen }"
    [style.min-height]="minHeight">
    <!-- HEADER -->
    <app-header (navToggled)="navToggledHandler($event)"></app-header>
    <!-- CONTENT -->
    <div id="layout-view" class="layout-view">
      <router-outlet></router-outlet>
    </div>
    <!-- FOOTER -->
    <app-footer></app-footer>
  </div> <!-- /.layout-canvas -->
</div> <!-- /.layout-overflow -->
